// =============================================================================
// guestName — display identity for anonymous "Try the App" guests
//
// The App DB `handle_new_user` trigger gives every guest the name
// "Traveller <n>" where n is derived from the first 32 bits of their uuid
// (migration 20261022). This reproduces that SAME number on the Platform side
// so the admin tables show a consistent, non-blank label even before that
// migration/backfill has run — and the number visibly corresponds to the uuid
// shown beneath it.
//
// Must stay in lock-step with the SQL:
//   abs( ('x' || left(hex,8))::bit(32)::int::bigint ) % 900000 + 100000
// =============================================================================

/** The guest's Traveller number — identical to the App DB trigger's value. */
export function travellerNumber(userId: string): number {
  const hex8 = userId.replace(/-/g, '').slice(0, 8);   // first 32 bits
  const signed = parseInt(hex8, 16) | 0;               // bit(32)::int is signed
  return (Math.abs(signed) % 900000) + 100000;         // 6-digit: 100000..999999
}

/** Name to show for a tenant user. Guests with no name fall back to
 *  "Traveller <n>"; anyone else without a name shows "No name". */
export function guestDisplayName(u: { full_name?: string | null; is_anonymous?: boolean; user_id: string }): string {
  const name = (u.full_name || '').trim();
  if (name) return name;
  if (u.is_anonymous) return `Traveller ${travellerNumber(u.user_id)}`;
  return 'No name';
}

/** Short uuid for the sub-line under the name, e.g. "8fe03156…". */
export function shortId(userId: string): string {
  return userId.slice(0, 8) + '…';
}
